import { formatArs, pricing } from './babyShowerPricing';

/**
 * Belső Nyugalom — kereskedelmi beállítások.
 * Ide kerül majd a valódi checkout link és a visszaszámláló vége.
 */

/** Checkout link — minden „Kérem az azonnali hozzáférést →” gomb ide visz. */
export const checkoutUrl = 'https://kit-baby-shower-listo-arg.impultienda.ar/checkout';

/**
 * A visszaszámláló pontos vége (ISO dátum, időzónával).
 * A számláló ehhez az időponthoz számol, újratöltéskor nem indul újra.
 */
export const countdownEnd = '2026-10-31T23:59:00+01:00';

/**
 * Baby Shower Dulce Recuerdo — checkout argentino (ImpulTienda).
 * SOLO el botón de la sección de oferta lleva acá.
 * Los demás botones de la landing llevan a la sección de oferta (#ajanlat).
 */
export const babyShowerCheckoutUrl = 'https://kit-baby-shower-listo-arg.impultienda.ar/checkout';
/** El precio se define en data/babyShowerPricing.ts (fuente única). */
export const babyShowerPrice = `${formatArs(pricing.offerPrice)} ARS`;
/**
 * Botón de arrepentimiento — IMPRESCINDIBLE antes de publicar.
 * Pegá acá la URL del formulario o mecanismo real de revocación.
 * Mientras esté vacío, el botón se muestra como pendiente y no envía nada.
 */
export const withdrawalFormUrl = '';
export const brand = 'Recursos Imprimibles AR';
export const salePrice = '5 970 Ft';
export const listPrice = '16 970 Ft';
export const guaranteeDays = 7;